import type React from 'react';
import styles from './index.module.css';

import BackgroundOfficeImage from '@/assets/images/office.jpg';
import { Button } from '../Button';

export type StartPageProps = {
  className?: string;
  chapterName: string;
  lessonName: string;
  onClick: () => void;
  showBackgroundImage?: boolean;
} & (
  | {
      lessonType: 'skill_check_test';
      timeLimitMinutes: number;
      questionsCount: number;
    }
  | {
      lessonType:
        | 'scenario'
        | 'practice'
        | 'goal_setting'
        | 'self_summarizing'
        | 'role_play'
        | 'goal_dialog'
        | 'reflection';
      timeLimitMinutes?: never;
      questionsCount?: never;
    }
);

export const StartPage: React.FC<StartPageProps> = ({
  chapterName,
  lessonName,
  lessonType,
  onClick,
  showBackgroundImage = true,
  timeLimitMinutes,
  questionsCount,
}) => {
  return (
    <div
      className={styles.startPage}
      style={{
        backgroundImage: showBackgroundImage
          ? `url(${BackgroundOfficeImage})`
          : 'none',
      }}
    >
      <div className={styles.bg}>
        <div className={styles.startPageInner}>
          <p className={styles.chapterName}>{chapterName}</p>
          <h2 className={styles.lessonName}>{lessonName}</h2>
          <Button
            onClick={() => {
              onClick();
            }}
          >
            スタート
          </Button>
          {lessonType === 'practice' && (
            <div className={styles.practiceAnnotation}>
              <h3 className={styles.practiceAnnotationTitle}>注意事項</h3>
              <p className={styles.practiceAnnotationBody}>
                ※全ての問題に回答すると次へ進めます。
                <br />
                なお演習問題には知識の習得・応用トレーニングのために、一部レッスンで扱っていない内容も含まれます。
                <br />
                正誤ではなく、内容理解を意識して取り組みましょう。
                <br />
              </p>
            </div>
          )}
          {lessonType === 'skill_check_test' && (
            <div className={styles.practiceAnnotation}>
              <h3 className={styles.practiceAnnotationTitle}>注意事項</h3>
              <p className={styles.practiceAnnotationBody}>
                受検前注意事項
                <br />
                スキルチェックテストは{timeLimitMinutes}分間 {questionsCount}
                問のテストです。
                <br />
                ※修了要件：7割以上の正答
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
